export enum BookingStatusType {
    Unpaid = 1,
    Booked = 2,
    Allocated = 3,
    RefundInProgress = 4,
    Completed = 5,
    Cancelled = 6,
    RefundInitiated = 7,
    PartiallyCompleted = 8,
    Refunded = 9,
    DriverWorkCompleted = 10,
    FarmerWorkCompleted = 11,
    FarmerCancelInProgress = 12,
    ServiceProviderCancelInProgress = 13,
    FarmerDateChange = 14,
    ServiceProviderDateChange = 15,
    DriverTripStarted = 16,
    DriverDateChange = 17,
    DriverBookingCancel = 18,
    ServiceProviderBookingCancel = 19
}


